export const SET_SEO_DATA = 'SET_SEO_DATA';